module.exports = __webpack_public_path__ + "asset/contract-add--6f659b.png";